import React, { useCallback, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import Zoom from 'react-img-hover-zoom';
import 'react-medium-image-zoom/dist/styles.css';
import ImageZoom from './ImageZoom';
import './Product.css';
import { Store } from './store/store';

const Product = ({ item }) => {
  const [showFullDescription, setShowFullDescription] = useState(false);
  const from = useLocation();
  const dispatch = useDispatch();

  const handleClick = useCallback(() => {
    dispatch({ type: 'ITEM_ADDED', item: from.state.item });
    console.log(Store.getState());
  }, [dispatch, from.state.item]);

  const renderPrice = () => {
    if (item.discountedPrice || item.discounted_Price) {
      return (
        <p className="original-price">
          <del>${from.state.item.price}</del>
          <span className="mx-2">
            ${from.state.item.discountedPrice || from.state.item.discounted_Price}
          </span>
        </p>
      );
    } else {
      return <p>${from.state.item.price}</p>;
    }
  };

  const renderDescription = () => {
    if (from.state.item.description.length > 20) {
      return (
        <p className="lead">
          {showFullDescription
            ? from.state.item.description
            : `${from.state.item.description.substring(0, 20)}...`}
          <a
            style={{ color: 'rgb(37, 150, 190)', margin: '0px 10px', cursor: 'pointer', textDecoration: 'underline' }}
            onClick={() => setShowFullDescription(!showFullDescription)}
          >
            {showFullDescription ? 'Read Less' : 'Read More'}
          </a>
        </p>
      );
    } else {
      return <p className="lead">{from.state.item.description}</p>;
    }
  };

  return (
    <div className="d-flex justify-content-center">
      <section className="py-5" style={{ color: 'white' }}>
        <div className="container px-4 px-lg-5 my-5 mx-2">
          <div className="row gx-4 gx-lg-5">
            <div className="col-md-6">
              <ImageZoom src={from.state.item.url || from.state.item.image} />
            </div>
            <div className="col-md-6">
              <div className="small mb-1">{from.state.item.catogery}</div>
              <h1 className="display-5 fw-bolder">{from.state.item.title}</h1>
              <div className="fs-5 mb-5">{renderPrice()}</div>
              {renderDescription()}
              <div className="d-flex">
                <button className="btn btn-outline-light flex-shrink-0" type="button" onClick={handleClick}>
                  <i className="bi-cart-fill me-1"></i>Add to cart
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Product;
